import React, { useEffect, useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import AxiosLibWithHeader2 from "../../../../../../Library/AxiosLibWithHeader2";
import { openToast } from "../../../../../../Library/ToastPopUp";
import { openModal } from "../../../../../../Library/ModalPopUp";
import PreviewPCFFirst from "../WPreviewPCF/PreviewPCFFirst";
import PreviewTimetables from "../timetables-draft/PreviewTimetables";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function MyPCF({
  student,
  stdStatus,
  fPCF,
  mypcf,
  setMypcf,
  eventid,
  studentid,
  acad,
  totalsks,
  setTotalSKS,
  selectedAcad,
}) {
  const [totalRemoved, setTotalRemoved] = useState(0);
  const [totalAdd, setTotalAdd] = useState(0);
  const [listData, setListData] = useState(mypcf);

  const tmpl_dt = student?.tmpl_hd?.tmpl_dt || [];
  const tmpl_max_credit =
    tmpl_dt.find((item) => item.key_id === "key.asc.rereg.pcf.maxcredit")
      ?.value || 24;
  const tmpl_check_amount =
    tmpl_dt.find((item) => item.key_id === "key.asc.rereg.pcf.getamount")
      ?.value || "";
  // console.log(tmpl_max_credit, tmpl_check_amount);
  const tmpl_check_amount_new_std =
    tmpl_dt.find((item) => item.key_id === "key.asc.rereg.pcf.newstdgetamount")
      ?.value || "0";

  useEffect(() => {
    setListData(mypcf);
  }, [mypcf]);

  const [maxSKS, setMaxSKS] = useState(tmpl_max_credit);

  const ResultData = useMemo(() => {
    let computedData = [...listData];

    computedData.sort((a, b) =>
      a.detail.coursetitle > b.detail.coursetitle ? 1 : -1,
    );

    const removedItems = computedData.filter(
      (item) => item.action_type === "remove",
    );
    setTotalRemoved(removedItems.length);

    const courseAdd = computedData.filter((item) => item.action_type === "add");
    setTotalAdd(courseAdd?.length || 0);

    const objSubjectUniq = computedData.reduce((accumulator, currentValue) => {
      if (
        currentValue.action_type === "add" &&
        currentValue.detail &&
        currentValue.detail.hasOwnProperty("not_billed") &&
        currentValue.detail.not_billed === 0
      ) {
        const {
          course_id,
          detail: { course_credit },
        } = currentValue;
        if (!accumulator.hasOwnProperty(course_id)) {
          accumulator[course_id] = course_credit;
        } else if (accumulator[course_id] !== course_credit) {
          accumulator[course_id] += course_credit;
        }
      }
      return accumulator;
    }, {});

    let tsks = 0;
    if (objSubjectUniq) {
      Object.keys(objSubjectUniq).map((k) => {
        tsks = tsks + objSubjectUniq[k];
      });
    }
    setTotalSKS(tsks);

    return computedData;
  }, [listData, setTotalSKS]);

  // useEffect(() => {
  //   if (stdStatus && stdStatus.corporate && stdStatus.corporate.id !== 3) {
  //     setMaxSKS(totalsks);
  //   } else {
  //     setMaxSKS(24);
  //   }
  // }, [totalsks])

  const handlerChangePCF = (data) => {
    setListData((prevListData) => {
      const cloneData = [...prevListData];
      if (data.origin === true) {
        return cloneData.map((item) => {
          if (item.section_id === data.section_id) {
            item.action_type = "remove";
          }
          return item;
        });
      } else {
        //return cloneData.filter((prev) => prev.section_id !== data.section_id);
        const updatedListData = cloneData.filter(
          (prev) => prev.section_id !== data.section_id,
        );
        setMypcf(updatedListData);
        return updatedListData;
      }
    });
  };

  const ListRemoveItem = ({ data }) => {
    const listRemoveCourse = data.filter(
      (item) => item.action_type === "remove",
    );
    const handlerRedoPCF = (value) => {
      setListData((prevListData) => {
        const cloneData = [...prevListData];
        return cloneData.map((item) => {
          if (item.section_id === value.section_id) {
            item.action_type = "add";
          }
          return item;
        });
      });
      openModal({ open: false });
    };
    return (
      <div className="hist-pcf">
        {Object.values(listRemoveCourse).length > 0 ? (
          listRemoveCourse.map((v, index) => (
            <div className="border p-3 rounded mb-8 shadow" key={index}>
              <div className="d-flex justify-content-start align-items-start">
                <div className="my-course w-100 ">
                  <span className="font-weight-bolder mb-1">
                    {v.detail.coursetitle}
                  </span>
                  <div>
                    <span className="text-muted font-weight-bold">
                      {v.detail.course_code
                        ? v.detail.course_code
                        : v.detail.code}
                    </span>
                  </div>
                </div>
                <div className="info-course mx-2 mx-xxl-5">
                  <span className="font-weight-bolder d-block">
                    Credit
                    <span className="ml-2 text-dark font-weight-bold">
                      {v.detail.course_credit}
                    </span>
                  </span>
                  <span className="text-muted text-capitalize">
                    {v.detail.course_type}
                  </span>
                </div>
                <button
                  className="btn btn-sm btn-icon btn-warning p-5"
                  type="button"
                  title={
                    student
                      ? "Restore to " + student.firstname + "'s PCF"
                      : "Redo the course"
                  }
                  onClick={() => handlerRedoPCF(v)}
                >
                  <i className="fas fa-redo"></i>
                </button>
              </div>
              <div className="cost_owner mt-5">
                <span className="font-weight-bolder d-block">
                  {v.detail.section_id ? v.detail.section_id : "-"}
                </span>
                <span className="font-weight-bolder text-muted">
                  Section ID
                </span>
              </div>
            </div>
          ))
        ) : (
          <p className="text-danger">No record found</p>
        )}
      </div>
    );
  };

  const PreviewPCF = () => {
    if (totalsks > maxSKS) {
      openToast({
        header: "Information",
        message: "The maximum total credit is " + maxSKS + " SKS",
      });
    } else {
      var cloneCourse = [...listData];
      var courses = cloneCourse.map((item) => {
        var obj = {};
        obj.action_type = item.action_type;
        obj.course_id = item.course_id;
        obj.section_id = item.section_id;
        return obj;
      });

      if (
        (stdStatus.term_intake.id === selectedAcad && tmpl_check_amount_new_std === "0") ||
        // stdStatus.enrollment_type_id === "mkt.enrollment.type.cooperation" ||
        // stdStatus.enrollment_type_id === "mkt.enrollment.type.exchange" ||
        (tmpl_check_amount && tmpl_check_amount === "0")
      ) {
        openModal({
          header: "",
          message: (
            <PreviewPCFFirst
              myprev={mypcf}
              data={[]}
              studentid={studentid}
              fpcf={fPCF}
              finish={false}
              eventid={eventid}
              student={student}
            />
          ),
          size: "xl",
        });
      } else {
        GET_PCF_AMOUNT(courses);
      }
    }
  };

  const [openPrev, setOpenPrev] = useState(false);
  const [pcfAmount, setPCFAmount] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const GET_PCF_AMOUNT = (courses) => {
    setPCFAmount({ loading: true, data: [], message: "" });
    var keys = {
      AppId: AuthDecode.AppID,
      AppEnv: AuthDecode.AppEnv,
      Secretkey: AuthDecode.secretkey,
    };

    var param = {
      courses: courses,
      studentid: studentid,
      term_id: acad.id,
    };

    var body = {
      parameters: param,
      target_data: "GET_PCF_AMOUNT",
    };

    const postData = {
      keys: keys,
      body: body,
    };

    AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
      if ("message" in response.response) {
        setPCFAmount({
          loading: false,
          data: [],
          message: response.response.message.user,
        });
        openToast({
          header: "Error",
          message:
            "Cannot proceed to the next step. Some required billing master data is missing. Please check items such as course, limit SKS by intake student. Error:" +
            response.response.message.user,
        });
      } else {
        var result = response.response.result;
        if (result === "success") {
          var dataResult = response.response.data;
          setPCFAmount({ loading: false, data: dataResult, message: "" });
          openModal({
            header: "",
            message: (
              <PreviewPCFFirst
                myprev={dataResult}
                data={listData}
                studentid={studentid}
                fpcf={fPCF}
                finish={false}
                eventid={eventid}
                student={student}
              />
            ),
            size: "xl",
          });
        } else {
          setPCFAmount({
            loading: false,
            data: [],
            message: "Failed preview PCF." + response.response.msg,
          });
          openToast({
            header: "Error",
            message: "Failed preview PCF." + response.response.msg,
          });
        }
      }
    });
  };

  return (
    <div className="card card-custom card-stretch gutter-b">
      <HeaderCardStd student={student} acad={acad} />

      <div
        className="card-body pt-0"
        style={{ maxHeight: "600px", overflowY: "auto" }}
      >
        <div className="table-responsive">
          <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
            <thead>
              <tr>
                <th>
                  <span className="text-dark">COURSE ({totalAdd})</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {ResultData.length > 0 ? (
                ResultData.map((v, index) =>
                  !v.action_type || v.action_type === "add" ? (
                    <tr key={index}>
                      <td className="px-0">
                        <div className="border p-3 rounded">
                          <div className="d-flex justify-content-start align-items-start">
                            <div className="my-course w-100 ">
                              <span className="font-weight-bolder mb-1">
                                {v.detail.coursetitle}
                              </span>
                              <div>
                                <span className="text-muted font-weight-bold">
                                  {v.detail.course_code
                                    ? v.detail.course_code
                                    : v.detail.code}
                                </span>
                              </div>
                            </div>
                            <div className="info-course mx-2 mx-xxl-5">
                              <span className="font-weight-bolder d-block">
                                Credit
                                <span className="ml-2 text-dark font-weight-bold">
                                  {v.detail.course_credit}
                                </span>
                              </span>
                            </div>
                            <button
                              className="btn btn-sm btn-icon btn-danger p-5"
                              type="button"
                              title={
                                student
                                  ? "Remove from " +
                                    student.firstname +
                                    "'s PCF"
                                  : "Remove the course"
                              }
                              onClick={() => handlerChangePCF(v)}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <div className="cost_owner mt-5">
                            <span className="font-weight-bolder d-block">
                              {v.detail.section_id ? v.detail.section_id : "-"}{" "}
                              /{v.detail?.section_name || ""}
                            </span>
                            <span className="font-weight-bolder text-muted">
                              Section ID / Name
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  ),
                )
              ) : (
                <tr>
                  <td colSpan={2}>No record found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card-footer">
        <div className="d-flex justify-content-between align-items-center">
          <span className="font-weight-bolder">
            Total credit: {totalsks} SKS{" "}
          </span>
          {totalsks > maxSKS && (
            <span className="label label-lg label-light-danger label-inline">
              Exceeded the maximum SKS
            </span>
          )}
          <div className="btn-group d-none">
            <button className="btn btn-sm btn-icon btn-warning" type="button">
              <i className="fa fa-trash text-dark"></i>
            </button>
            <button
              className="btn btn-sm btn-light-warning btn-hover-light-warning"
              type="button"
              onClick={() =>
                openModal({
                  header: "Removed Course List",
                  message: <ListRemoveItem data={listData} />,
                })
              }
            >
              <span className="font-weight-bolder text-dark text-uppercase">
                {totalRemoved} course removed
              </span>
            </button>
          </div>
        </div>
        <div className="my-5">
          {AuthDecode.remotedBy ? (
            <div className="alert alert-danger">
              <div className="alert-title text-left">
                <i className="icon-1x text-white flaticon-warning-sign mr-2"></i>
                You cannot submit this PCF.
                <br />
                This PCF belongs to{" "}
                <b>
                  Mr/Mrs.{" "}
                  {AuthDecode.currentData.given_name +
                    " " +
                    AuthDecode.currentData.family_name}
                </b>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="text-center">
          {/* <button
            className="btn btn-lg btn-light btn-block font-weight-bolder text-uppercase text-primary px-9 py-4 mb-5"
            title="Preview Timetables"
            onClick={()=>openModal({size:'xl', header:`${student?.firstname}'s Class schedule draft`,message:<PreviewTimetables courses={mypcf} termid={acad?.id || 0} />})}
          >
            Preview Class Schedule Draft
          </button> */}
          <button
            className="btn btn-lg btn-primary btn-block font-weight-bolder text-uppercase px-9 py-4"
            title="Preview and Approve"
            onClick={() =>
              PreviewTimetableNApprove(
                PreviewPCF,
                mypcf,
                acad?.id || 0,
                student,
              )
            }
            disabled={pcfAmount.loading}
          >
            {pcfAmount.loading ? "Processing..." : "Next and Preview"}
          </button>
        </div>
      </div>
    </div>
  );
}

const PreviewTimetableNApprove = (PreviewPCF, courses, termid, student) => {
  const RenderTimetable = () => {
    const [loading, setLoading] = useState(false);
    const [has_conflict, setHasConflict] = useState(false);
    const [prev_amount, setPrevAmmount] = useState(false);

    const handleNextAndApprove = () => {
      setPrevAmmount(true);
      PreviewPCF();
    };

    return (
      <div>
        <PreviewTimetables
          courses={courses}
          termid={termid}
          setLoading={setLoading}
          has_conflict={has_conflict}
          setHasConflict={setHasConflict}
        />
        {/* {has_conflict ? (
          <div className="alert alert-warning">
            <div className="alert-title text-left">
              <span className="font-weight-bold d-block font-size-lg text-dark">
                <i className="icon-1x text-dark flaticon-warning-sign mr-2"></i>
                Unable to Approve PCF
              </span>
              <span className="font-size-lg text-dark">
                Approval cannot be completed because there are unresolved time
                conflicts.
              </span>
            </div>
          </div>
        ) : ( */}
        {loading && (
          <div className="text-right">
            <button
              className="btn btn-lg btn-primary text-uppercase"
              type="button"
              onClick={handleNextAndApprove}
              disabled={prev_amount}
            >
              {prev_amount ? "Processing..." : "Next and Approve"}
            </button>
          </div>
        )}
        {/* )} */}
      </div>
    );
  };

  openModal({
    header: `${student?.firstname}'s Class schedule draft`,
    message: <RenderTimetable />,
    size: "xl",
  });
};

const HeaderCardStd = ({ student, acad }) => {
  return (
    <div className="card-header align-items-center border-0 mt-4">
      <h3 className="card-title align-items-start flex-column">
        <span className="font-weight-bolder text-dark">
          {student ? student.firstname + "'s PCF" : "UNKNOW STUDENT"}
        </span>
        <span className="text-muted mt-3 font-weight-bold font-size-sm">
          Periode {acad ? (acad.name ? acad.name : "-") : "-"}
        </span>
      </h3>
    </div>
  );
};
